import * as React from "react";
import Typography from "@material-ui/core/Typography";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Grid from "@material-ui/core/Grid";
import ViewHeaderBar from "../components/ViewHeaderBar";
import * as LoginStore from '../login/loginStore'

import { ApplicationState } from "../store";
import { connect } from "react-redux";
import { UserRole } from "../login/LoginModels";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { HelpElement, ElementType, HelpBlockData } from "./helpTypes";
import { userManual } from "./userManual";
import { adminManual } from "./adminManual";
import { localizations } from '../localization/localization';
import { manualLocalizations } from '../localization/manualLocalization';

const elementHelper = (element: HelpElement, index: number) => {
    if (element.elementType === ElementType.LINE) {
        return (
            <Grid item key={`element_line_${index}`}>
                <Typography key={index} variant="body1">
                    {element.data}
                </Typography>
            </Grid>
        );
    }
    if (element.elementType === ElementType.TEXT1) {
        return (
            <Grid item key={`element_text1_${index}`}>
                <div className="helpViewChapter" key={index}>
                    <p>
                        {element.data}
                    </p>
                </div>
            </Grid>
        );
    }
    if (element.elementType === ElementType.HEADER1) {
        return (
            <Grid item key={`element_header1_${index}`}>
                <div className="helpViewChapter" key={index}>
                    <h3>
                        {element.data}
                    </h3>
                </div>
            </Grid>
        );
    }
    if (element.elementType === ElementType.IMAGE) {
        return (
            <Grid item key={`element_image_${index}`}>
                <img style={{ maxWidth: "100%" }} src={element.data} />
            </Grid>
        );
    }
    if (element.elementType === ElementType.HEADER) {
        return (
            <Grid item key={`element_header_${index}`}>
                <Typography variant="subtitle1" key={index}>
                    {element.data}
                </Typography>
            </Grid>
        );
    }
    return (
        <Grid item key={`element_helper_${index}`}>
            <Typography variant="body1" key={index}>
                {element.data}
            </Typography>
        </Grid>
    );
};

interface HelpBlockProps {
    id?: string,
    helpIndex: number;
    title: string,
    elements: HelpElement[],
    isOpen: boolean
}

const HelpBlock: React.SFC<HelpBlockProps> = ({ helpIndex, id, title, elements, isOpen }) => {
    return (
        <Grid id={id} item>
            <ExpansionPanel defaultExpanded={isOpen}>
                <ExpansionPanelSummary>
                    <Typography id={id} variant="h6">
                        {helpIndex}. {title}
                    </Typography>
                </ExpansionPanelSummary>
                <div id={id}>
                    <ExpansionPanelDetails>
                    <Grid container direction="column">
                        {elements.map((element, index) => elementHelper(element, index))}
                    </Grid>
                    </ExpansionPanelDetails>
                </div>
            </ExpansionPanel>
        </Grid>
    );
}



interface HelpProps {
    title: string,
    intro: string,
    helps: HelpBlockData[],
    anchorId?: string;
}

const userHelp = {
    title: manualLocalizations.userManual.userManualTitle,
    intro: manualLocalizations.userManual.userManualIntro,
    helps: userManual,
}

const adminHelp = {
    title: manualLocalizations.adminManual.adminManualTitle,
    intro: manualLocalizations.adminManual.adminManualIntro,
    helps: adminManual,
}
const Help: React.SFC<HelpProps> = ({ title, intro, helps, anchorId }) => {
    return (
        <Grid container direction="column" spacing={1}>
            <Grid item>
                <ViewHeaderBar title={title} />
                <Typography>
                    {intro}
                </Typography>
            </Grid>
            {helps.map((helpItem, index) => (
                <Grid item key={index}>
                    <HelpBlock
                        id={helpItem.id}
                        helpIndex={index + 1}
                        key={index}
                        isOpen={!!(anchorId && helpItem.id === anchorId)}
                        {...helpItem}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

interface MatchParams {
    id: string;
    location: string;
    hash: string;
}

type HelpViewProps = LoginStore.LoginState & RouteComponentProps<MatchParams>;

class HelpView extends React.Component<HelpViewProps> {

    public componentDidMount() {
        const anchorId = this.props.location.hash ? this.props.location.hash.replace("#", "") : undefined;

        if (anchorId) {
            const element = document.getElementById(anchorId);
            if (element) {
                element.scrollIntoView();
            }
        }
    }

    public render() {
        const isAdmin = this.props.role === UserRole.Admin;

        const anchorId = this.props.location.hash ? this.props.location.hash.replace("#", "") : undefined;

        return (
            <Grid item xs={12}>
                <Help {...userHelp} anchorId={anchorId} />
                {isAdmin ? <Help {...adminHelp} /> : null}
            </Grid>
        );
    }
}

export default withRouter(connect<any, any, any>((state: ApplicationState) => state.login, null)(HelpView));



// WEBPACK FOOTER //
// ./src/help/HelpView.tsx